import { api } from "..";
const endpoint = "/api/quality-control";

export const getAllQCReports = async (query) => {
  return await api.get(`${endpoint}`, { params: query });
};

export const getQCReportById = async (id) => {
  return await api.get(`${endpoint}/${id}`);
};

export const createQCReport = async (data) => {
  return await api.post(`${endpoint}`, data);
};

export const updateQCReport = async (id, data) => {
  return await api.put(`${endpoint}/${id}`, data);
};

export const deleteQCReport = async (id) => {
  return await api.delete(`${endpoint}/${id}`);
};

export const updateDefectReports = async (data) => {
  return await api.put(`${endpoint}/defect-reports`, data);
};

export const getDefectReportSummary = async (reportHeaderId) => {
  return await api.get(`${endpoint}/${reportHeaderId}/defect-summary`);
};

export const updateDefectCount = async (data) => {
  return await api.patch(`${endpoint}/defect-report`, data);
}; 